<template>
  <sui-modal class="wrapper" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Scale service
    </sui-modal-header>
    <sui-modal-content :scrolling="!!entity">
      <sui-form :error="hasApiErrors" :warning="!isScalable" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <h3 class="ui header">Service</h3>
        <sui-form-field>
          <sui-dropdown selection v-model="serviceId" direction="downward" :options="servicesList" placeholder="Select service..." />
        </sui-form-field>
        <FormService v-model="entity" :mode="mode" v-if="entity" />
        <sui-message warning content="The service dosn't support scaling" v-if="serviceId" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Scaling started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import FormService from '@/components/forms/Service'
  import ModalForm from '@/mixins/ModalForm'
  import utils from '@/utils'

  export default {
    name: 'ModalScaleService',
    mixins: [
      ModalForm,
    ],
    components: {
      FormService,
    },
    data() {
      return {
        serviceId: null,
        entity: null,
      }
    },
    computed: {
      ...mapGetters(['services', 'servicesById']),
      mode() {
        return this.needsMigration ? 'migrating' : 'scaling'
      },
      servicesList() {
        return this.services.map(service => {
          return {
            image: {src: service._logo},
            value: service.id,
            text: service.name,
          }
        })
      },
      service() {
        return this.servicesById[this.serviceId]
      },
      needsMigration() {
        return this.service ? this.service.configuration && this.service.configuration !== this.service.constructor.fields.configuration.enum[1].value : false
      },
      isScalable() {
        return this.service ? this.service.constructor.methods.scale : false
      },
    },
    watch: {
      serviceId() {
        this.entity = null
        if (this.isScalable) {
          this.$nextTick(() => {
            this.entity = {
              ...this.service,
              configuration: this.needsMigration ? this.service.constructor.fields.configuration.enum[1].value : this.service.configuration,
              hosts: [],
            }
          })
        }
      },
    },
    methods: {
      open(entity = {}) {
        this.visible = true
        this.serviceId = entity.id
      },
      reset() {
        this.apiErrors = null
        this.success = false
        this.entity = null
        this.serviceId = null
      },
      submit() {
        const method = this.needsMigration ? 'migrate' : 'scale'
        this.apiErrors = null
        this.loading = true
        utils.reachGoal(`${method.toUpperCase()}_SERVICE_TRY`)
        return this.entity[method]().then(() => {
          utils.reachGoal(`${method.toUpperCase()}_SERVICE_SUCCESS`)
          this.success = true
          setTimeout(() => {
            this.close()
          }, 1000)
        }).catch(error => {
          utils.reachGoal(`${method.toUpperCase()}_SERVICE_FAIL`)
          this.apiErrors = error
        }).finally(() => {
          this.loading = false
        })
      },
    },
    created() {
      this.$modals.scaleService = this
    },
  }
</script>
